import { Stepper } from "@mantine/core";

interface onStepProps {
  active: number;
  firstStep: string;
  secondStep: string;
  finalStep: string;
  firstDescription: string;
  secondDescription: string;
  finalDescription: string;
}

export function ThreeStepsStepper({
  active,
  firstStep,
  secondStep,
  finalStep,
  firstDescription,
  secondDescription,
  finalDescription,
}: onStepProps) {
  return (
    <>
      <Stepper
        color="indigo"
        active={active}
        allowNextStepsSelect={false}
        styles={{
          root: {
            marginTop: "15px",
            marginBottom: "15px",
          },
        }}
      >
        <Stepper.Step label={firstStep} description={firstDescription}></Stepper.Step>
        <Stepper.Step label={secondStep} description={secondDescription}></Stepper.Step>
        <Stepper.Step label={finalStep} description={finalDescription}></Stepper.Step>
      </Stepper>
    </>
  );
}
